import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from "@angular/forms";
import { DataTableModule } from "angular2-datatable";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { Ng2Webstorage } from "ngx-webstorage/dist/app";
import { FileUploadModule } from "ng2-file-upload/ng2-file-upload";
import { SolicitudInclusionComponent } from "./solicitud-inclusion.component";
import { SolicitudInclusionService } from "./solicitud-inclusion.service";
import { CalendarModule } from 'primeng/primeng';
import { SolicitudMovimientosComponent } from "./solicitudes-movimientos.component";
import { SolicitudExclusionComponent } from "./solicitud-exclusion.component";
import { SolicitudExclusionService } from "./solicitud-exclusion.service";
import { DataFilterPipeExclusionCedula, DataFilterPipeExclusionNombre } from "./solicitud-exclusion.filter";
import { Ng2CompleterModule } from "ng2-completer";
import { SolicitudCambiosService } from "./solicitud-cambios.service";
import { SolicitudCambiosComponent } from "./solicitud-cambios.component";
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';

@NgModule({
    declarations: [SolicitudMovimientosComponent, SolicitudInclusionComponent, SolicitudExclusionComponent,DataFilterPipeExclusionCedula, DataFilterPipeExclusionNombre, SolicitudCambiosComponent],
    imports: [
        BrowserModule,
        Ng2CompleterModule,       
        HttpModule,
        FormsModule,
        DataTableModule,
        CalendarModule,
        Ng2Bs3ModalModule,
        FileUploadModule,
        Ng2Webstorage,MultiselectDropdownModule],
    providers: [SolicitudInclusionService, SolicitudExclusionService,SolicitudCambiosService],
    exports: [SolicitudMovimientosComponent]

})

export class SolicitudMovimientosModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/solicitudes/solicitudes-movimientos.module.ts